import { ChipProps } from "@mui/material";

export function getChipProps(params: string): ChipProps {
	if (params === 'PHOTO'){
		return {
			label: "FOTO",
			sx: {
				"& .MuiChip-label": {
					color: "background.default"
				},
				backgroundColor: "#07568a",
				borderRadius: 1
			},
		}
	}

	if (params === 'PLANIMETRY'){
		return {
			label: "PLANIMETRIA",
			sx: {
				"& .MuiChip-label": {
					color: "background.default"
				},
						backgroundColor: "#669cbc",
				borderRadius: 1
			}
		}
	}

	if (params === 'ATTACHMENT'){
		return {
			label: "ALLEGATO",
			sx: {
				"& .MuiChip-label": {
					color: "background.default"
				},
				backgroundColor: "#66bc8b",
				borderRadius: 1
			}
		}
	}

	if (params === 'TOUR_3D'){
		return {
			label: "TOUR 3D",
			sx: {
				"& .MuiChip-label": {
					color: "background.default"
				},
				backgroundColor: "#078a63",
				borderRadius: 1
			}
		}
	}

	if (params === 'OTHER'){
		return {
			label: "ALTRO",
			sx: {
				"& .MuiChip-label": {
					color: "background.default"
				},
				backgroundColor: "#adadad",
				borderRadius: 1
			}
		}
	}


	return {
		label: "Errore",
		color: "error",
		sx: {
			"& .MuiChip-label": {
				color: "background.default"
			},
			borderRadius: 1
		}
	}
}
